import {
  useQuery
} from "@tanstack/react-query";

import {
  ShopByCategorySection
} from "../components/category/ShopByCategorySection";
import {
  WhyRiniSection
} from "../components/home/HomeSections";

import {
  CmsGiftHamperSection
} from "../components/home/CmsGiftHamperSection";
import {
  CmsHeroSection
} from "../components/home/CmsHeroSection";
import {
  CmsMakingRiniSection
} from "../components/home/CmsMakingRiniSection";
import {
  CmsIngredientSection
} from "../components/home/CmsIngredientSection";
import {
  CmsTestimonialsSection
} from "../components/home/CmsTestimonialsSection";
import {
  CmsInstagramSection
} from "../components/home/CmsInstagramSection";
import {
  DynamicProductSection
} from "../components/home/DynamicProductSection";
import {
  findHomeSection,
  useHomeSections
} from "../components/home/HomeSectionCms";
import {
  getBestSellers,
  getCategories,
  getFeaturedProducts,
  getNewArrivals
} from "../services/catalog";

export function HomePage() {
  const categoriesQuery = useQuery({
    queryKey: ["categories"],
    queryFn: getCategories
  });

  const homeSectionsQuery =
    useHomeSections();

  const shopByRitualSection =
    findHomeSection(
      homeSectionsQuery.data,
      "SHOP_BY_RITUAL"
    );

  const bestSellersSection =
    findHomeSection(
      homeSectionsQuery.data,
      "BEST_SELLERS"
    );

  const featuredProductsSection =
    findHomeSection(
      homeSectionsQuery.data,
      "FEATURED_PRODUCTS"
    );

  const newArrivalsSection =
    findHomeSection(
      homeSectionsQuery.data,
      "NEW_ARRIVALS"
    );

  return (
    <>
      <CmsHeroSection />

      {(
        categoriesQuery.data &&
        (
          !shopByRitualSection ||
          shopByRitualSection.isVisible
        )
      ) && (
        <ShopByCategorySection
          categories={categoriesQuery.data}
          eyebrow={
            shopByRitualSection?.eyebrow ??
            "Shop by ritual"
          }
          title={
            shopByRitualSection?.title ??
            "Explore every RiNi collection"
          }
          subtitle={
            shopByRitualSection?.subtitle ??
            "Discover thoughtfully prepared bodycare, haircare, lip care and gifting collections made in small batches."
          }
        />
      )}

      {(
        !bestSellersSection ||
        bestSellersSection.isVisible
      ) && (
        <DynamicProductSection
          queryKey="best-sellers"
          queryFn={() =>
            getBestSellers(8)
          }
          eyebrow={
            bestSellersSection?.eyebrow ??
            "Customer favourites"
          }
          title={
            bestSellersSection?.title ??
            "RiNi Best Sellers"
          }
          description={
            bestSellersSection?.subtitle ??
            "Discover the RiNi products our customers return to again and again."
          }
          emptyMessage="Best sellers are coming soon."
        />
      )}

      {(
        !featuredProductsSection ||
        featuredProductsSection.isVisible
      ) && (
        <DynamicProductSection
          queryKey="featured-products"
          queryFn={() =>
            getFeaturedProducts(8)
          }
          eyebrow={
            featuredProductsSection?.eyebrow ??
            "Handpicked by RiNi"
          }
          title={
            featuredProductsSection?.title ??
            "Featured Products"
          }
          description={
            featuredProductsSection?.subtitle ??
            "A curated selection of RiNi favourites chosen for everyday self-care."
          }
          emptyMessage="Featured products are coming soon."
          background="bg-[#f7f1e9]"
        />
      )}

      {(
        !newArrivalsSection ||
        newArrivalsSection.isVisible
      ) && (
        <DynamicProductSection
          queryKey="new-arrivals"
          queryFn={() =>
            getNewArrivals(8)
          }
          eyebrow={
            newArrivalsSection?.eyebrow ??
            "Fresh from RiNi"
          }
          title={
            newArrivalsSection?.title ??
            "New Arrivals"
          }
          description={
            newArrivalsSection?.subtitle ??
            "Explore the latest products added to the RiNi collection."
          }
          emptyMessage="New products are coming soon."
        />
      )}
      <WhyRiniSection />
      <CmsMakingRiniSection />
      <CmsIngredientSection />
      <CmsGiftHamperSection />
      <CmsTestimonialsSection />
      <CmsInstagramSection />
    </>
  );
}
